'use strict';
$(document).ready(function () {
    moment.locale("ja");
});

let zip_error1 = false;
let zip_error2 = false;

// 郵便番号チェック
function zipCodeCheck1(subName) {
    setNormal('#addr_zip_search' + subName);
    setNormal('#addr_zip1' + subName);
    zip_error1 = false;

    if ($('#addr_zip1' + subName).val().trim() == '' && !zip_error2) {
        setError('#addr_zip1' + subName);
        zip_error1 = true;
        return false;
    } else if (!zip_error2) {
        setNormal('#addr_zip1' + subName);
    }
    return true;
}

function zipCodeCheck2(subName) {
    zip_error2 = false;
    setNormal('#addr_zip_search' + subName);
    setNormal('#addr_zip2' + subName);

    if ($('#addr_zip2' + subName).val().trim() == '' && !zip_error1) {
        setError('#addr_zip2' + subName);
        zip_error2 = true;
        return false;
    } else if (!zip_error1) {
        setNormal('#addr_zip2' + subName);
    }
    return true;
}

// コンボボックスの一致するTextの項目を選択する
function textSelector(parentSelector, childText) {
    let prefecture = 0;
    $.each($("select" + parentSelector + " " + "option:contains('" + childText + "')"), function () {
        if ($(this).text().trim() === childText) {
            $(this).parent('select').val($(this).val());
            prefecture = $(this).parent('select').val();
            return false;
        }
    });
    return prefecture;
}

// 郵便番号が'0000000'だった場合、会員の住所確認
function checkAddress() {
    // 郵便番号の取得
    var postal_code;
    postal_code = $('.zip_code1').val() + $('.zip_code2').val();

    if (postal_code == '0000000') {
        // 住所の取得
        $.ajax({
            url: '/address/get_address?user_id=' + $('#user_id').val(),
            type: 'get',
            dataType: 'json'
        }).then(function (data) {
            // 海外の住所でない場合、登録されている住所を番地に設定する。
            if (data != '- - -') { // '- - -'は海外を選択した時に登録される住所
                // 都道府県の設定
                $('.prefecture option[value="48"]').prop('selected', true);

                // 市区町村の設定
                $('.city > option').remove();
                $('.ctiy').append($('.city').html('<option value="-">-</option>'));

                // 町域の設定
                $('.town > option').remove();
                $('.town').append($('.town').html('<option value="-">-</option>'));

                // 選択住所以下の住所の設定
                $('.addr_address').val(data);
            }
        });
    }
}

// 都道府県、市区町村、町域を指定してコンボボックスの中身を入れ替える
window.addressSelect = function (pref, addr1, addr2, subName) {
    // 都道府県コンボ選択
    let prefecture = textSelector('#addr_pref' + subName, pref);
    setNormal('#addr_pref' + subName);
    let options = '<option value=\"%s\" %s>%s</option>';

    // 市区町村、町域の取得
    if (prefecture == 48) {
        // 市区町村コンボの中身を差し替える
        let cities = '<select id="addr_city' + subName + '" name="addr_city' + subName + '" class="form-control" required><option value="">市区町村</option>';
        cities += $.format(options, '-', 'selected', '-');
        cities += '</select>';

        $('#addr_city' + subName).replaceWith(cities);
        setNormal('#addr_city' + subName);

        // 町域コンボの中身を差し替える
        let towns = '<select id="addr_town' + subName + '" name="addr_town' + subName + '" class="form-control" required><option value="">町域</option>';
        towns += $.format(options, '-', 'selected', '-');
        towns += '</select>';

        $('#addr_town' + subName).replaceWith(towns);
        setNormal('#addr_town' + subName);

        // 選択住所以下の住所を差し替える
        $('#addr_address' + subName).val('-');
    } else {
        // 都道府県から市区町村一覧取得
        $.ajax({
            url: '/address/city-search?prefecture=' + prefecture,
            type: 'get',
            dataType: 'json'
        }).then(function (data) {
            // 取得した内容で市区町村コンボの中身を差し替える
            let cities = '<select id="addr_city' + subName + '" name="addr_city' + subName + '" class="form-control" required><option value="">市区町村</option>';
            $.each(data, function (index, value) {
                let selected = (value.city === addr1) ? 'selected=\"selected\"' : '';
                cities += $.format(options, value.city, selected, value.city);
            });
            cities += '</select>';

            $('#addr_city' + subName).replaceWith(cities);
            setNormal('#addr_city' + subName);
        }, function () {
            console.log('市区町村一覧取得error');
            return false;
        });

        // 市区町村名称から町域一覧取得
        $.ajax({
            url: '/address/town-search?city=' + encodeURIComponent(addr1),
            type: 'get',
            dataType: 'json'
        }).then(function (townData) {
            // 取得した内容で町域コンボの中身を差し替える
            let towns = '<select id="addr_town' + subName + '" name="addr_town' + subName + '" class="form-control" required><option value="">町域</option>';
            $.each(townData, function (index, value) {
                let selected = (value.address === addr2) ? 'selected=\"selected\"' : '';
                towns += $.format(options, value.address, selected, value.address);
            });
            towns += '</select>';

            $('#addr_town' + subName).replaceWith(towns);
            setNormal('#addr_town' + subName);
        }, function () {
            console.log('町域一覧取得error');
            return false;
        });
    }

    // 住所関係のコントロールのバリデーションをOKにする
    setNormal('#addr_zip_search' + subName);
    setNormal('#addr_zip1' + subName);
    setNormal('#addr_zip2' + subName);

    // 選択した住所を表示
    var fulladdress = pref + " " + addr1 + " " + addr2;
    $('#addr_selected_address' + subName ).text(fulladdress);
    $('#pre_address' + subName ).val(fulladdress)
};

window.addEventListener('DOMContentLoaded', function (e) {

    function clickAddrZipSearch(subName) {

        setNormal('#addr_zip_search' + subName);

        if (!zipCodeCheck1(subName)) {
            $('#addr_zip1' + subName + '_error').text('郵便番号1を入力してください。');
            return;
        }
        if (!zipCodeCheck2(subName)) {
            $('#addr_zip2' + subName + '_error').text('郵便番号2を入力してください。');
            return;
        }

        setNormal('#addr_zip1' + subName);
        setNormal('#addr_zip2' + subName);

        // 郵便番号から住所を取得
        $.ajax({
            url: '/address/zipcode-search?zipCode=' + $('#addr_zip1' + subName).val() + $('#addr_zip2' + subName).val(),
            type: 'get',
            dataType: 'json'
        }).then(function (data) {

            // 正しくチェック済みの郵便番号を保存
            if (data.length >= 1) {
                if (subName == '_billing') {
                    // 請求書送付先の郵便番号
                    $('#confirm_billing_postal_code').val($('#addr_zip1' + subName).val() + $('#addr_zip2' + subName).val());
                    console.log('請求書送付先の郵便番号:'+ $('#confirm_billing_postal_code').val());
                } else {
                    // アカウントの郵便番号
                    $('#confirm_postal_code').val($('#addr_zip1' + subName).val() + $('#addr_zip2' + subName).val());
                    console.log('アカウントの郵便番号:'+ $('#confirm_postal_code').val());
                }
            }

            // 郵便番号に紐付く住所が1件のときはモーダル画面を出さずに住所を選択
            if (data.length === 1) {
                addressSelect(data[0].name, data[0].city, data[0].address, subName);
                return;
            }else if ( data.length == 0 ){
                //0件ならアラート表示
                $('#address-error-modal-label').html('存在しない郵便番号です。');
                $('[data-remodal-id=address-error-modal]').remodal().open();
                return;
            }

            // モーダル画面の住所一覧を空に
            $('#zipcode_address_list').children().remove();

            // モーダル画面に住所一覧を追加
            $.each(data, function (index, value) {
                let elem = '<tr>';
                elem += $.format('<td class="use" data-label="住所：">%s %s %s</td>', value.name, value.city, value.address);
                elem += $.format('<td class="btns"><button type="button" class="btn btn-blk address_select" id="address_select_modal_btn_%d" data-name="%s" data-city="%s" data-address="%s">これを選ぶ</button></td>', index, value.name, value.city, value.address);
                elem += '</tr>';
                $('#zipcode_address_list').append(elem);
                $('#address_select_modal_btn_' + index).unbind();
                $('#address_select_modal_btn_' + index).click( function(){
                    addressSelect( $(this).data('name'), $(this).data('city'), $(this).data('address'), subName );
                    $('[data-remodal-id=zipcodeSelect]').remodal().close();
                })
            });
            $('[data-remodal-id=zipcodeSelect]').remodal().open();

        }, function () {
            //エラーでアラート表示
            $('#address-error-modal-label').html('郵便番号検索に失敗しました。');
            $('[data-remodal-id=address-error-modal]').remodal().open();
            console.log('郵便番号検索エラーerror');
            setError('#addr_zip_search' + subName);
            $('#addr_zip1' + subName).focus();
            $('#addr_zip1' + subName).select();
        });
    }

    // 郵便番号から住所を検索してコンボの中身の差し替え、住所の選択を行う
    $('#addr_zip_search').on('click', function () {
        clickAddrZipSearch('');
    });

    // 郵便番号から住所を検索してコンボの中身の差し替え、住所の選択を行う
    $('#addr_zip_search_corp').on('click', function () {
        clickAddrZipSearch('_corp');
    });

    // 請求書受け取り住所を郵便番号から住所検索
    $('#addr_zip_search_billing').on('click', function () {
    	clickAddrZipSearch('_billing');
    });

    // 数字のみに制限
    $(document).on('keydown', '.input_number_only', function (e) {
        let k = e.keyCode;
        let str = String.fromCharCode(k);
        if (!(str.match(/[0-9]/) || (37 <= k && k <= 40) || k === 8 || k === 46 || k === 9 || (96 <= k && k <= 105) || !(k === 86 && k === 18))) {
            // if (k == 9 && e.shiftKey) {
            //     ShiftTab();
            // }
            return false;
        }
    });

    // 万が一数字以外が入っている場合削除
    $(document).on('keyup', '.input_number_only', function (e) {
        this.value = this.value.replace(/[^0-9]+/i, '');
    });

    // 万が一数字以外が入っている場合削除
    $(document).on('blur', '.input_number_only', function () {
        this.value = this.value.replace(/[^0-9]+/i, '');
    });

    // CIMコード用関数
    // 数字とアポストロフィのみに制限
    $(document).on('keydown', '.input_cim_code_only', function(e){
        let k = e.keyCode;
        let str = String.fromCharCode(k);
        if(!(str.match(/[0-9']/) || (37 <= k && k <= 40) || k === 8 || k === 46 || k === 9 || (96 <= k && k <= 105) || (k == 55 && e.shiftKey))) {
            // if (k == 9 && e.shiftKey) {
            //     ShiftTab();
            // }
            return false;
        }
    });
    // CIMコード用関数
    // 万が一数字とアポストロフィ以外が入っている場合削除
    $(document).on('keyup', '.input_cim_code_only', function(e){
        this.value = this.value.replace(/[^0-9']+/i,'');
    });
    // CIMコード用関数
    // 万が一数字とアポストロフィ以外が入っている場合削除
    $(document).on('blur', '.input_cim_code_only',function(){
        this.value = this.value.replace(/[^0-9']+/i,'');
    });

    // 特定のコントロールで、最大桁数まで入力されたときに次のコントロールにフォーカスを移動する
    function zip1Keyup(zip1Id, zip2Id)
    {
        const max = $(zip1Id).attr('maxlength');  //最大文字数
        const current = $(zip1Id).val().length;  //現在の文字数

        //最大文字数を超えたかどうか？
        if (current >= max) {
            $(zip2Id).focus();
            $(zip2Id).select();
        }
    }
    function zip2Keyup(zip2Id, searchId)
    {
        const max = $(zip2Id).attr('maxlength');  //最大文字数
        const current = $(zip2Id).val().length;  //現在の文字数

        //最大文字数を超えたかどうか？
        if (current >= max) {
            $(searchId).focus();
        }
    }

    // 配送情報入力画面、個人会員登録、配送パターン画面での郵便番号フィールドのカーソル制御
    $('#addr_zip1').on('keyup', function () {
        zip1Keyup('#addr_zip1', '#addr_zip2');
    });
    $('#addr_zip2').on('keyup', function () {
        zip2Keyup('#addr_zip2', '#addr_zip_search');
    });

    // 法人、系列会員登録での郵便番号フィールドのカーソル制御
    $('#addr_zip1_corp').on('keyup', function () {
        zip1Keyup('#addr_zip1_corp', '#addr_zip2_corp');
    });
    $('#addr_zip2_corp').on('keyup', function () {
        zip2Keyup('#addr_zip2_corp', '#addr_zip_search_corp');
    });

    // 請求書送付先の郵便番号フィールドのカーソル制御
    $('#addr_zip1_billing').on('keyup', function () {
        zip1Keyup('#addr_zip1_billing', '#addr_zip2_billing');
    });
    $('#addr_zip2_billing').on('keyup', function () {
        zip2Keyup('#addr_zip2_billing', '#addr_zip_search_billing');
    });

	//選択されてる住所から初期値を選択
	setAddressesFromPrefix( '' );
	setAddressesFromPrefix( '_corp' );
	setAddressesFromPrefix( '_billing' );

	//初期値から各selectの内容を復活
	function setAddressesFromPrefix( subName ){
		var addressPrefix = $('#pre_address' + subName).val();
		if ( !addressPrefix || addressPrefix.length == 0 ){
			return;
		}
		var addresses = addressPrefix.split(' ');
		if ( addresses.length != 3 ){
			return;
		}
		//都道府県
		var prefvalues = $( '#addr_pref' + subName + ' option' );
		var preffound = false;
		var prefid = -1;
		$.each( prefvalues, function(index, element){
			if ( $(element).text() == addresses[0] ){
				$(element).prop('selected', true);
				prefid = $(element).val();
			}
		});

        if('48' == prefid) {
            return;
        }
		//市区町村
        $.ajax({
            url: '/address/city-search?prefecture=' + prefid,
            async: false,
            type: 'get',
            dataType: 'json'
        }).then(function (citydata) {
            // 取得した内容でコンボの中身を差し替え
            let cities = '<select id="addr_city'  + subName + '" name="addr_city' + subName + '" class="form-control city" required><option value="">市区町村</option>';
            $.each(citydata, function (index, value) {
            	var selected = ( value.city == addresses[1] ? 'selected' : '' );
                cities += $.format('<option value="%s" %s>%s</option>', value.city, selected, value.city);
            })
            cities += '</select>';
            $('#addr_city' + subName).replaceWith(cities);

        }, function () {
            console.log('error');
        });

        //町域
        $.ajax({
            url: '/address/town-search?city=' + encodeURIComponent(addresses[1]),
            async: false,
            type: 'get',
            dataType: 'json'
        }).then(function (towndata) {

            // 取得した内容でコンボの中身を差し替え
            let towns = '<select id="addr_town' + subName + '" name="addr_town' + subName + '" class="form-control town" required><option value="">町域</option>';
            $.each(towndata, function (index, value) {
            	var selected = ( value.address == addresses[2] ? 'selected' : '' );
                towns += $.format('<option value="%s" %s>%s</option>', value.address, selected, value.address);
            });
            towns += '</select>';
            $('#addr_town' + subName).replaceWith(towns);

        }, function () {
            console.log('error');
        });
	}

	//都道府県を変更したときのイベントセット
    $(document).on('change', '[id^=addr_pref]', function(){
        var id_name = $(this).attr('id');
        var subName = id_name.replace('addr_pref', '')

        changeAddrPref(subName);
    });

    // 都道府県コンボ変更時の処理
    function changeAddrPref(subName) {
    	//選択チェック
        var value = $('#addr_pref' + subName).val();

        if ( !value || value == '' || value == '48'){
        	//「都道府県」を選んだ際は無視
        	// 市区町村、町域はリセットする
            //setError( '#addr_pref' + subName );
            //setError( '#addr_city' + subName );
            //setError( '#addr_town' + subName );
            if ('48' == value) {
                $('#addr_zip1' + subName).val('000');
                $('#addr_zip2' + subName).val('0000');
                if ('' == subName) {
                    $('#addr_address_per').val('-');
                } else if ('_corp' == subName) {
                    $('#addr_address_corp').val('-');
                } else if ('_billing' == subName) {
                    $('#billing_address').val('-');
                    $('#web').prop('checked', true);
                    $('#post').prop('checked', false);
                    $('#post').prop('disabled', true);
                    $('#post').parent().find('label').css('cursor', 'default');
                    $('#post').parent().css('display', 'none');
                    $('#web').click();
                }

                let cities = '<select id="addr_city'  + subName + '" name="addr_city' + subName + '" class="form-control" required><option value="-" selected>-</option></select>';
                $('#addr_city' + subName).replaceWith(cities);
                $('#addr_town' + subName).replaceWith('<select id="addr_town' + subName + '" name="addr_town' + subName + '" class="form-control" required><option value="-" selected>-</option></select>');

                let fulladdress = $('#addr_pref' + subName + ' option:selected').text() + ' ' + '-' + ' ' + '-';
                $('#pre_address' + subName ).val( fulladdress );
                $('#addr_selected_address' + subName).text( fulladdress );
            } else {
                let cities = '<select id="addr_city'  + subName + '" name="addr_city' + subName + '" class="form-control" required><option value="-" selected>-</option></select>';
                $('#addr_city' + subName).replaceWith(cities);
                $('#addr_town' + subName).replaceWith('<select id="addr_town' + subName + '" name="addr_town' + subName + '" class="form-control" required><option value="-" selected>-</option></select>');
            }

        	return;
        } else {
            if ('_billing' == subName) {
                $('#post').prop('disabled', false);
                $('#post').parent().find('label').css('cursor', 'pointer');
                $('#post').parent().css('display', 'block');
            }
        }

        // 都道府県コードから市区町村一覧取得
        $.ajax({
            url: '/address/city-search?prefecture=' + $('#addr_pref' + subName).val(),
            type: 'get',
            dataType: 'json'
        }).then(function (citydata) {
            // 取得した内容でコンボの中身を差し替え
            let cities = '<select id="addr_city'  + subName + '" name="addr_city' + subName + '" class="form-control" required><option value="">市区町村</option>';
            $.each(citydata, function (index, value) {
                cities += $.format('<option value="%s">%s</option>', value.city, value.city);
            })
            cities += '</select>';

            $('#addr_city' + subName).replaceWith(cities);
            $('#addr_town' + subName).replaceWith('<select id="addr_town' + subName + '" name="addr_town' + subName + '" class="form-control" required><option value="">町域</option></select>');

            $('#addr_selected_address' + subName).text('')
            $('#pre_address' + subName).val('');

            setNormal('#addr_zip_search' + subName);
            $('#addr_zip1' + subName).removeClass("is-invalid");
            $('#addr_zip2' + subName).removeClass("is-invalid");

        }, function () {
            console.log('error');
        });
    }

	//市区町村を変更したときのイベントセット
    $(document).on('change', '[id^=addr_city]', function(){
        var id_name = $(this).attr('id');
        var subName = id_name.replace('addr_city', '')

        changeAddrCity(subName);
    });

    // 市区町村コンボ変更時の処理
    function changeAddrCity(subName) {
    	//選択チェック
        var value = $('#addr_city' + subName).val();
        if ( !value || value == '市区町村' ){
        	//「市区町村」を選んだ際は無視
        	// 町域はリセットする
            $('#addr_town' + subName).replaceWith('<select id="addr_town' + subName + '" name="addr_town' + subName + '" class="form-control" required><option value="">町域</option></select>');
            //setError( '#addr_pref' + subName );
            //setError( '#addr_city' + subName );
            //setError( '#addr_town' + subName );
        	return;
        }

        // 市区町村名称から町域一覧を取得
        $.ajax({
            url: '/address/town-search?city=' + encodeURIComponent($('#addr_city' + subName).val()),
            type: 'get',
            dataType: 'json'
        }).then(function (towndata) {

            // 取得した内容でコンボの中身を差し替え
            let towns = '<select id="addr_town' + subName + '" name="addr_town' + subName + '" class="form-control" required><option value="">町域</option>';
            $.each(towndata, function (index, value) {
                towns += $.format('<option value="%s">%s</option>', value.address, value.address);
            });
            towns += '</select>';
            $('#addr_town' + subName).replaceWith(towns);

            $('#addr_selected_address' + subName).text('');
            $('#pre_address' + subName ).val();

            setNormal('#addr_zip_search' + subName);
            $('#addr_zip1' + subName).removeClass("is-invalid");
            $('#addr_zip2' + subName).removeClass("is-invalid");

        }, function () {
            console.log('error');
        });
    }

	//町域を変更したときのイベントセット
    $(document).on('change', '[id^=addr_town]', function(){
        var id_name = $(this).attr('id');
        var subName = id_name.replace('addr_town', '')

        changeAddrTown(subName);
    });

    // 町域コンボ変更時の処理
    function changeAddrTown(subName) {
    	//選択チェック
        var value = $('#addr_town' + subName).val();
        if ( !value || value == '町域' ){
        	//「町域」を選んだ際は無視
        	return;
        }

        // 都道府県コードを取得
        let pref_code = $('#addr_pref' + subName).val();
        // 市区町村名を取得
        let city = $('#addr_city' + subName).val();

        // 町域名称から郵便番号を取得
        $.ajax({
            url: '/address/code-search?pref_code=' + pref_code + '&city=' + encodeURIComponent(city) + '&address=' + encodeURIComponent($('#addr_town' + subName).val()),
            type: 'get',
            dataType: 'json'
        }).then(function (codeData) {
			console.log('changeAddrTown');
            $('#addr_zip1' + subName).val(codeData.code.substr(0, 3));
            $('#addr_zip2' + subName).val(codeData.code.substr(3));

            // 郵便番号を保存
            if (subName == '_billing') {
                // 請求書送付先の郵便番号
                $('#confirm_billing_postal_code').val($('#addr_zip1' + subName).val() + $('#addr_zip2' + subName).val());
                console.log('請求書送付先の郵便番号:'+ $('#confirm_billing_postal_code').val());
            } else {
                // アカウントの郵便番号
                $('#confirm_postal_code').val($('#addr_zip1' + subName).val() + $('#addr_zip2' + subName).val());
                console.log('アカウントの郵便番号:'+ $('#confirm_postal_code').val());
            }

            // 選択された住所をセット
            var fulladdress = $('#addr_pref' + subName + ' option:selected').text() + " " + $('#addr_city' + subName + ' option:selected').text() + " " + $('#addr_town' + subName + ' option:selected').text();
            $('#addr_selected_address' + subName ).text( fulladdress );
            console.log(fulladdress);
            $('#pre_address' + subName ).val( fulladdress );

            setNormal('#addr_zip_search' + subName);
            setNormal('#addr_zip1' + subName);
            setNormal('#addr_zip2' + subName);
            setNormal('#addr_town' + subName);

        }, function () {
            console.log('error');
        });
    }
    // 住所の確認
    checkAddress();
});

(function () {
    'use strict';
    window.addEventListener('load', function () {
        let forms = document.getElementsByClassName('needs-validation');
        let validation = Array.prototype.filter.call(forms, function (form) {
            form.addEventListener('submit', function (event) {
                if (form.checkValidity() === false) {
                    event.preventDefault();
                    event.stopPropagation();
                }
                form.classList.add('was-validated');
            }, false);
        });
    }, false);

})();

window.setError = function (id) {
    $(id).removeClass("is-valid").addClass("is-invalid");
}

window.setNormal = function (id) {
    $(id).removeClass("is-invalid").removeClass("is-valid");
}

$.format = function (format) {
    let i = 0,
        j = 0,
        r = "",
        next = function (args) {
            j += 1;
            i += 1;
            return args[j] !== void 0 ? args[j] : "";
        };

    for (i = 0; i < format.length; i++) {
        if (format.charCodeAt(i) === 37) {
            switch (format.charCodeAt(i + 1)) {
                case 115:
                    r += next(arguments);
                    break;
                case 100:
                    r += Number(next(arguments));
                    break;
                default:
                    r += format[i];
                    break;
            }
        } else {
            r += format[i];
        }
    }
    return r;
};
